import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'primereact/chart';
import { EmployeeMetricStatus } from '../../utils/types';
import dollarGreen from '../../assets/dollarGreen.png';

interface PayoutSummaryProps {
    monthlyMetrics?: any;
    selectedmetrics?: EmployeeMetricStatus;
}

export const PayoutSummary = ({ monthlyMetrics, selectedmetrics }: PayoutSummaryProps) => {
    const chartRef = useRef<Chart | null>(null);
    const [chartData, setChartData] = useState<any>({});
    const [chartOptions, setChartOptions] = useState<any>({});
    const [metricTargetedVals, setMetricTargetedVals] = useState(0);
    const [metricReported, setmetricReported] = useState(0);
    const [metricAttained, setmetricAttained] = useState(0);

    useEffect(() => {
        if (selectedmetrics) {
            setMetricTargetedVals(selectedmetrics.total_metrics_targeted);
            setmetricReported(selectedmetrics.total_metrics_reported);
            setmetricAttained(selectedmetrics.total_metrics_attained);
        }
        if ((monthlyMetrics?.length ?? 0) > 0) {
            const total = monthlyMetrics?.length;
            const attained = monthlyMetrics?.filter((m: any) => m.metric_attained).length;
            const remaining = total - attained;

            // gradient chart
            const canvas = chartRef.current?.getCanvas();
            if (!canvas) return;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            const gradient = ctx.createLinearGradient(0, 0, 0, 150);
            gradient.addColorStop(0, '#C8F29B');
            gradient.addColorStop(1, '#00D6BB');

            const data = {
                labels: ['Attained', 'Remaining'],
                datasets: [
                    {
                        data: [attained, remaining],
                        backgroundColor: [gradient, '#daf5f1'],
                        hoverBackgroundColor: [gradient, '#daf5f1'],
                        // borderRadius: 100, // <-- makes rounded ends
                        // cutout: '80%',
                        // circumference: 600, // less than 360 to leave a gap
                        // rotation: 85, // rotate to make the gap less visible
                    },
                ],
            };
            const options = {
                cutout: '60%',
                plugins: {
                    legend: { display: false },
                },
            };
            setChartData(data);
            setChartOptions(options);
        } else setChartData([]);
    }, [monthlyMetrics, selectedmetrics]);

    return (
        <div className="text-center" style={{ width: '25%' }}>
            <h4 style={{ textAlign: 'left' }}>Payout</h4>
            <div style={{ display: 'flex' }}>
                <div className="flex items-center p-2 gap-2">
                    <Chart
                        ref={chartRef}
                        type="doughnut"
                        data={chartData}
                        options={chartOptions}
                        style={{ width: '100px', margin: '0 auto' }}
                    />
                    <div className="text-lg font-medium mt-2">
                        {selectedmetrics?.total_metrics_attained}/{metricReported}
                    </div>
                </div>
                <div>
                    <p className="text-sm mt-1 text-gray-500">
                        You are just{' '}
                        <span style={{ color: '#2AA154' }}> {metricTargetedVals - metricAttained}</span>{' '}
                        metric away from qualifying for minimum payout!
                    </p>
                </div>
            </div>
            <div style={{ backgroundColor: '#D9F6B9', borderRadius: '20px' }} className="p-2 mt-2">
                <img src={dollarGreen} alt="targetArrow" />
                &nbsp; Meet <span style={{ color: '#2AA154' }}>{metricTargetedVals}</span> metrics to qualify
                for <span style={{ color: '#2AA154' }}>min.</span> payout.
            </div>
        </div>
    );
};
